// Storage に保存される form の shape。
// Vue 側 (loan-aplus-03 / loan-aplus-04 / loan-aplus-05 / loan-aplus-tpoint) の
// `const fields = reactive({...})` 宣言と1対1で揃える。値は radio / select に由来して
// 文字列で持つことが多く ("true" / "false" / enum 文字列 / 空文字列)、
// mapEntryForm が kubb shape に正規化する境界で必要に応じて narrowing する。

export interface AplusPart1 {
  cityTownVillageRuby: string
  townNameAndBlockNumberRuby: string
  streetNumberRuby: string
  buildingNameAndRoomNumberRuby: string
  residenceType: string
  lengthOfResidencyYear: string
  lengthOfResidencyMonth: string
  isBearerOfHousingCost: string
  emailAddress: string
  emailAddressConfirm: string
  hasDriversLicense: string
  driversLicenseNumber: string
}

export interface AplusPart2 {
  isMarried: string
  hasChildren: string
  headOfHousehold: string
  headOfHouseholdOthers: string
  isLivingWithHeadOfHousehold: string
  dependents: string
  contactRelation: string
  contactRelationOther: string
  postalCode: string
  prefecture: string
  cityTownVillage: string
  townNameAndBlockNumber: string
  streetNumber: string
  buildingNameAndRoomNumber: string
  phoneNumber: string
  headOfHouseholdLastName: string
  headOfHouseholdFirstName: string
  headOfHouseholdAnnualIncome: string
  monthlyCreditCardPayment: string
}

export interface AplusPart3 {
  occupation: string
  hasActiveIncome: string
  annualIncome: string
  employmentStatus: string
  employmentStatusOther: string
  companyName: string
  companyNameRuby: string
  companyPhone: string
  companyPhonePart1: string
  companyPhonePart2: string
  companyPhonePart3: string
  yearsOfServiceYear: string
  yearsOfServiceMonth: string
  industry: string
  industryOther: string
  jobTitle: string
  jobTitleOther: string
  employeeCount: string
  department: string
  extensionNumber: string
  pensionType: string
  pensionTypeOther: string
  hasRealEstateIncome: string
  annualPensionAndRealEstateIncome: string
  hasOtherIncome: string
  hasOtherIncomeTrue: string
}

export interface AplusPart4 {
  optInForCard: string
  applyForCard: boolean
  applyForNETStation: string
  firstNameAlphabet: string
  lastNameAlphabet: string
  isPersonalCard: boolean
  cardLimit: string
  pinNumber: string
  pinNumberConfirm: string
  applyForETC: string
  activeLoanCount: string
  activeLoanAmount: string
  hasActiveLoan: string
  forPersonalUse: boolean
}

const aplusPart1StorageKey = 'aplusPart1'
const aplusPart2StorageKey = 'aplusPart2'
const aplusPart3StorageKey = 'aplusPart3'
const aplusPart4StorageKey = 'aplusPart4'

export const useAplusForm = () => {
  const saveForm = (label: string, data: object) => {
    storage(label).setItem(data)
  }

  const loadForm = (label: string) => {
    return storage(label).getItem()
  }

  // storage が空のとき getItem は `{} as T` を返す (utils/session-storage.ts:6)。
  // 起こりうるのは "Vue が保存した完全な fields" か "空の {}" のいずれか。後者ではフィールド
  // アクセスが undefined を返すが TS 上は string なので、mapEntryForm 側で
  // `if (form.field !== '')` などの既存ガードと併せて取り扱う。
  const loadAllForms = (): {
    aplusPart1: AplusPart1
    aplusPart2: AplusPart2
    aplusPart3: AplusPart3
    aplusPart4: AplusPart4
  } => {
    return {
      aplusPart1: storage<AplusPart1>(aplusPart1StorageKey).getItem(),
      aplusPart2: storage<AplusPart2>(aplusPart2StorageKey).getItem(),
      aplusPart3: storage<AplusPart3>(aplusPart3StorageKey).getItem(),
      aplusPart4: storage<AplusPart4>(aplusPart4StorageKey).getItem(),
    }
  }

  const isEditMode = () => {
    const aplusForm = storage<AplusPart4>(aplusPart4StorageKey).getItem()
    return !!aplusForm.optInForCard
  }

  return {
    saveForm,
    loadForm,
    loadAllForms,
    isEditMode,
  }
}
